import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Custom logging function
import axios from "axios";
import JSZip from "jszip"; // Ensure the zip library is imported
import {
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getRefFromId,
} from "../../models/DataFunctions";
const generateBoth = async (
  xmlUrl,
  oid,
  listlots,
  urlinsulator,
  token,
  orgId,
  phone,
  folderId,
  email,
  address,
  name,
  prefix,
  handleSignCoords,
  orgData,
  new_model = false
) => {
  const url = prefix + `folders/${folderId}/xml/generate_pdf`;
  const fileResponse = await axios.get(xmlUrl, { responseType: "arraybuffer" });
  try {
    if (fileResponse.status !== 200) {
      throw new Error(`Failed to download file: ${fileResponse.status}`);
    }

    const zip = await JSZip.loadAsync(fileResponse.data);
    const xmlContent = await processZipBytes(zip);
    if (!xmlContent) throw new Error("No XML file found in the ZIP archive");

    let start = new Date();
    // Fetch organization data from Firestore

    const logo =
      orgData.config?.ath?.hide_my_logo === true
        ? null
        : orgData.logo || "https://i.ibb.co/8Nc2tS4/Placeholder.png";
    // Prepare the request body for the PDF generation
    const body = {
      oid: oid,
      footer: `${name} - ${address}\nTéléphone : ${phone} - Mail : ${email}`,
      type: "carbon",
      batch: listlots,
      logo: logo,
      new_model: new_model,
    };

    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    };
    const generateCarbonFormData = new FormData();
    generateCarbonFormData.append(
      "file",
      new Blob([xmlContent]),
      "extracted.xml"
    );
    generateCarbonFormData.append("request", JSON.stringify(body));

    // Send the request to generate the carbon PDF
    const response = await axios.post(url, generateCarbonFormData, {
      headers: headers,
    });

    if (response.status == 200) {
      const url = response.data.url.trim().replace(/"/g, "");
      let sign_coords = handleSignCoords(response.data.sign_coords);
      const urlcarbon = url;

      // Prepare the request to merge the two PDFs
      const mergeUrl = prefix + `folders/${folderId}/xml/merge`;
      const mergeBody = {
        pdf1: urlinsulator,
        pdf2: urlcarbon,
      };
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      // Make the POST request to merge PDFs
      const mergeResponse = await fetch(mergeUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(mergeBody),
      });

      const currentUser = getAuthCentral().currentUser;
      if (!currentUser) {
        return "";
      }

      const userRef = doc(getFirestore(), "user", currentUser.uid);
      const userSnapshot = await getDoc(checkDB(userRef));
      const orgId = userSnapshot.get("org_id");

      const responseText = await mergeResponse.text();
      let end = new Date();
      let elapsed = end - start;
      // Log the action
      await addLogDocument(
        mergeUrl,
        prefix,
        userRef,
        orgId,
        mergeResponse.status.toString(),
        "",
        "",
        JSON.stringify(mergeBody),
        responseText,
        "POST",
        elapsed
      );

      if (mergeResponse.ok) {
        const responseBody = responseText;
        const cleanMerge = responseBody.trim().replace(/"/g, "");
        return { url: cleanMerge, sign_coords: sign_coords };
      } else {
        console.error("Failed to merge PDFs:", mergeResponse.status);
        return "";
      }
    } else {
      console.error("Failed to create carbon PDF:", response.status);
      return "";
    }
  } catch (error) {
    console.error("Exception occurred:", error);
    return "";
  }
};

export const processZipBytes = async (zip) => {
  for (const filename in zip.files) {
    if (filename.endsWith(".xml") && !filename.includes("/")) {
      return await zip.file(filename).async("string");
    }
  }
  return null;
};

export default generateBoth;
